import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { addressListInterface } from '@/components/lookupInput/types';
import { Category, Filter, FilterObject } from '@interface';
import { AppString } from '@utils';

type districtOptionsInterface = {
	id: string,
	module: string
}

type customSearchDataFilters = {
	Housingfilters: Filter[],
	Addfilters: FilterObject[],
	LogicalOperator: 'AND' | 'OR'
	SelectedHousingType: Category
	navigateParam: string
}

interface RootSliceState {
	activePageId: number;
	isSideMenuOpened: boolean;
	isSmallMenuOpened: boolean;
	isLoggedIn: boolean;
	addressState: addressListInterface;
	districtOptionState: districtOptionsInterface,
	customSearchOptionState: customSearchDataFilters

}
const initialState: RootSliceState = {
	activePageId: 1,
	isSideMenuOpened: true,
	isSmallMenuOpened: false,
	isLoggedIn: localStorage.getItem(AppString.user_token) ? true : false,
	addressState: {
		properties: {
			name: '',
			borough: '',
			postalcode: '',
			label: '',
			addendum: {
				pad: {
					bbl: ''
				}
			}
		},
	},
	districtOptionState: {
		id: "",
		module: ""
	},
	customSearchOptionState: {
		Housingfilters: [],
		Addfilters: [],
		LogicalOperator: 'AND',
		SelectedHousingType: 'all',
		navigateParam: ''
	}


};

export const appSlice = createSlice({
	name: 'rootSlice',
	initialState,
	reducers: {
		setIsSideMenuOpened: (state, action: PayloadAction<boolean>) => {
			state.isSideMenuOpened = action.payload;
		},
		setIsSmallMenuOpened: (state, action: PayloadAction<boolean>) => {
			return {
				...state,
				isSmallMenuOpened: action.payload,
			};
		},

		setIsUserLoggedInHandler: (state, action: PayloadAction<boolean>) => {
			state.isLoggedIn = action.payload;
		},
		setActivePageId: (state, action: PayloadAction<number>) => {
			state.activePageId = action.payload;
		},
		setAddressState: (state, action: PayloadAction<addressListInterface>) => {
			state.addressState = action.payload;
		},
		setDistrictOptionState: (state, action: PayloadAction<districtOptionsInterface>) => {
			state.districtOptionState = action.payload;
		},
		setCustomSearchOptionState: (state, action: PayloadAction<customSearchDataFilters>) => {
			state.customSearchOptionState = action.payload;
		},
		clearCustomSearchOptionState: (state) => {
			state.customSearchOptionState = initialState.customSearchOptionState;
		}
	},
});

export const {
	setActivePageId,
	setIsSideMenuOpened,
	setIsSmallMenuOpened,
	setAddressState,
	setDistrictOptionState,
	setCustomSearchOptionState,
	clearCustomSearchOptionState,
	setIsUserLoggedInHandler
} = appSlice.actions;

export default appSlice.reducer;
